import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



import DashBoardFirstSection from "./DashBoardComponent/DashBoardFirstSection";
import DashBoardFourthSection from "./DashBoardComponent/DashBoardFourthSection";
import DashBoardSecondSection from "./DashBoardComponent/DashBoardSecondSection";
import DashBoardThirdSection from "./DashBoardComponent/DashBoardThirdSection";
import { DashBoardContainer } from "./dashBoardNewStyles";


const DashBoardNew = ({
  history,
  //states
  selectedOrganization,
  jobsInfoTodayIsloading,
  jobsInfoToday,
  jobsCustomIsloading,
  jobsCustom,
  attendanceIsLoading,
  attendanceData,
  //add invoice states
  invoiceIsLoading,
  invoiceData,
  //add performers states
  performersIsLoading,
  topPerformers,
  //add revenue states
  revenueIsLoading,
  lastYearRevenue,
  thisYearRevenue,
  currentMonthIndex,
  //add top customers states
  topCustomersIsLoading,
  topCustomers,
  //add estimation states
  estimationIsLoading,
  estimationData,
  //add organization sales states
  organizationSalesIsLoading,
  organizationSalesData,
  //add project count states
  projectCountIsLoading,
  projectCountData,
  //add timesheet count states
  timesheetCountIsLoading,
  timesheetCountData,
  //actions
  getJobInfoToday,
  getJobInfoCustom,
  getDashboardAttendance,
  getDashboardInvoice,
  getDashboardPerformers,
  getDashboardRevenue,
  getDashboardTopCustomers,
  getDashboardEstimation,
  getDashboardOrganizationSales,
  getDashboardProjectCount,
  getDashboardTimesheetCount,
}) => {
  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  

  return (
    <div className="content">
      <DashBoardContainer>
        {/* 1st section */}
        <DashBoardFirstSection
          selectedOrganization={selectedOrganization}
          jobsInfoToday={jobsInfoToday}
          jobsInfoTodayIsloading={jobsInfoTodayIsloading}
          getJobInfoToday={getJobInfoToday}
          getDashboardInvoice={getDashboardInvoice}
          invoiceIsLoading={invoiceIsLoading}
          invoiceData={invoiceData}
          getDashboardProjectCount={getDashboardProjectCount}
          projectCountIsLoading={projectCountIsLoading}
          projectCountData={projectCountData}
          getDashboardTimesheetCount={getDashboardTimesheetCount}
          timesheetCountIsLoading={timesheetCountIsLoading}
          timesheetCountData={timesheetCountData}
          history={history}
        />
        <DashBoardSecondSection 
          selectedOrganization={selectedOrganization}
          getJobInfoCustom={getJobInfoCustom}
          jobsCustomIsloading={jobsCustomIsloading}
          jobsCustom={jobsCustom}
          getDashboardAttendance={getDashboardAttendance}
          attendanceIsLoading={attendanceIsLoading}
          attendanceData={attendanceData}
          getDashboardPerformers={getDashboardPerformers}
          performersIsLoading={performersIsLoading}
          topPerformers={topPerformers}
          history={history}
        />
        
        {!isOperationType && <DashBoardThirdSection
          getDashboardRevenue={getDashboardRevenue}
          revenueIsLoading={revenueIsLoading}
          lastYearRevenue={lastYearRevenue}
          thisYearRevenue={thisYearRevenue}
          currentMonthIndex={currentMonthIndex}
          selectedOrganization={selectedOrganization}
          getDashboardOrganizationSales={getDashboardOrganizationSales}
          organizationSalesIsLoading={organizationSalesIsLoading}
          organizationSalesData={organizationSalesData}
        />}
        <DashBoardFourthSection
          getDashboardTopCustomers={getDashboardTopCustomers}
          topCustomersIsLoading={topCustomersIsLoading}
          topCustomers={topCustomers}
          selectedOrganization={selectedOrganization}
          getDashboardEstimation={getDashboardEstimation}
          estimationIsLoading={estimationIsLoading}
          estimationData={estimationData}

        />
      </DashBoardContainer>
    </div>
  );
};

export default DashBoardNew;